module.exports = require("html-pdf");


//////////////////
// WEBPACK FOOTER
// external "html-pdf"
// module id = 103
// module chunks = 0